// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SoftwareOwnershipSchema = z.enum(['CUSTOM_WEB_APP','THIRD_PARTY_SAAS','INFRASTRUCTURE'] as const);

export type SoftwareOwnershipType = `${z.infer<typeof SoftwareOwnershipSchema>}`

export default SoftwareOwnershipSchema;
